import * as React from 'react';
import { inject } from 'mobx-react';
import { ClientLogger } from 'bernie-client';
import { AnalyticsStore } from 'bernie-core';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';

export interface MesoLoggerProps {
  analytics?: AnalyticsStore;
}

@inject('analytics')
export class MesoLogger extends React.Component<MesoLoggerProps> {
  public componentDidMount() {
    const logger = ClientLogger.getLoggerWithIdentifier('shopping-pwa-meso-logger');
    const adsLoggingInterface = {
      info: (name, extra) => {
        logger.logEvent(new SystemEvent(SystemEventLevel.INFO, name), this.objectToStringArray(extra));
      },
      warn: (name, extra) => {
        logger.logEvent(new SystemEvent(SystemEventLevel.WARN, name), this.objectToStringArray(extra));
      },
      error: (name, extra) => {
        logger.logEvent(new SystemEvent(SystemEventLevel.ERROR, name), this.objectToStringArray(extra));
      },
      trackEvent: (rfrr, linkName, events, trackImmediate) => {
        this.props.analytics.trackEvent(rfrr, linkName, this.props.analytics.omnitureData, events, trackImmediate);
      },
      trackAction: (rfrr, linkName, events, trackImmediate) => {
        this.props.analytics.trackEvent(rfrr, linkName, this.props.analytics.omnitureData, events, trackImmediate);
      }
    };

    window.meso = window.meso || {};
    window.meso.initialize = window.meso.initialize || [];
    window.meso.initialize.push({
      type: 'logger',
      logger: adsLoggingInterface,
      loggerType: 'bernie-logger'
    });
  }

  private objectToStringArray(json) {
    if (typeof json === 'string') {
      return json;
    }
    const arr = [];
    const extraData = json || {};
    Object.entries(extraData).forEach(([key, value]) => {
      arr.push(`${key}=${value}`);
    });

    return arr;
  }

  public render() {
    return null;
  }
}
